var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutPageYellowSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 216,
    viewBox: "0 0 209 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.426 107.775C160.426 139.319 135.275 164.93 104.296 164.93C73.3176 164.93 48.166 139.319 48.166 107.775C48.166 76.2315 73.3176 50.6208 104.296 50.6208C135.275 50.6208 160.426 76.2315 160.426 107.775Z",
    fill: "#FFC456"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.002 39.6552L104.296 0L113.515 39.6552H95.002Z",
    fill: "#FFC456"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6531 47.0148L68.0801 6.53345L90.06 40.5558L72.6531 47.0148Z",
    fill: "#FFC456"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1401 61.6605L36.2168 25.2349L68.3018 49.5687L54.1401 61.6605Z",
    fill: "#FFC456"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6741 81.8647L12.6133 53.9258L50.9677 65.567L41.6741 81.8647Z",
    fill: "#FFC456"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7317 105.222L0 89.0742L39.977 86.6709L36.7317 105.222Z",
    fill: "#FFC456"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.977 128.879L0 126.551L36.7317 110.404L39.977 128.879Z",
    fill: "#FFC456"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8939 150.059L12.6133 161.7L41.6741 133.761L50.8939 150.059Z",
    fill: "#FFC456"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3018 166.056L36.2168 190.39L54.1401 153.964L68.3018 166.056Z",
    fill: "#FFC456"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.06 175.069L68.0801 209.091L72.6531 168.61L90.06 175.069Z",
    fill: "#FFC456"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.515 175.971L104.296 215.626L95.002 175.971H113.515Z",
    fill: "#FFC456"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.864 168.61L140.511 209.091L118.457 175.069L135.864 168.61Z",
    fill: "#FFC456"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M154.378 153.964L172.302 190.39L140.217 166.056L154.378 153.964Z",
    fill: "#FFC456"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M166.841 133.761L195.976 161.7L157.621 150.059L166.841 133.761Z",
    fill: "#FFC456"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.785 110.404L208.517 126.551L168.613 128.955L171.785 110.404Z",
    fill: "#FFC456"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.613 86.6709L208.517 89.0742L171.785 105.222L168.613 86.6709Z",
    fill: "#FFC456"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M157.621 65.567L195.976 53.9258L166.841 81.8647L157.621 65.567Z",
    fill: "#FFC456"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M140.217 49.5687L172.302 25.2349L154.378 61.6605L140.217 49.5687Z",
    fill: "#FFC456"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.457 40.5562L140.511 6.45874L135.864 47.0152L118.457 40.5562Z",
    fill: "#FFC456"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPageYellowSun);
export default __webpack_public_path__ + "static/media/AboutPageYellowSun.9511d19579131f6975737f1ba7aa6b02.svg";
export { ForwardRef as ReactComponent };